module.exports = 'query GetOpportunity($id:ID!){opportunity(id:$id){...FullOpportunityReload}}'